export default interface RouterOptionBlock {
  panel: boolean,
  general: boolean,
  portForward: boolean,
  wifi: boolean,
  icmp: boolean,
  arp: boolean,
  dio: boolean,
  signal: boolean
}